import type { EntityContentLayoutProps } from '@backstage/plugin-catalog-react/alpha';

import { EntityContentLayoutBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { IpenMasonryLayout } from '@ipen-portal/plugin-layout-react';

import { WarningContent } from '../components/WarningContent';

export const IpenMasonryLayoutExtension = EntityContentLayoutBlueprint.make({
  name: 'ipen-masonry-layout',
  params: {
    loader:
      async () =>
        ({ cards }: EntityContentLayoutProps) => {
          const infoCards = cards
            .filter(card => card.type === 'info')
            .map(({ element }) => element);
          const summaryCards = cards
            .filter(card => !card.type)
            .map(({ element }) => element);
          const contentCards = cards
            .filter(card => card.type === 'content')
            .map(({ element }) => element);

          return (
            <>
              <WarningContent />
              <IpenMasonryLayout
                columns={[infoCards, summaryCards, contentCards]}
              />
            </>
          );
        },
  },
});
